<template>
    <div :style="borderColor ? `border-color: ${borderColor} !important;` : 'border-color: #f1f1f1 !important;'" class="subheadline rounded-lg my-border blue-grey--text px-3 py-2 text-center font-weight-bold text-wrap">
           <slot name="head"></slot>
            {{head || emptyState}}
            <br v-if="column">
        <span class="subheadline black--text font-weight-bold" :class="contentColor ? `${contentColor}--text` : ''">
            {{content || emptyState}}
            <slot name="content"></slot>
        </span>
    </div>
</template>
<script>
export default {
props: ["head", "content", "emptyState", "column", "borderColor", "contentColor"],
name:"BeeOutlinedHeaderInfo",
data(){
    return{
    }
},
computed:{
  localValue: {
      get: function() {
          return this.content
      },
      set: function(content) {
          this.$emit('input', content)
      }
  }
},
}
</script>
<style scoped>
.my-border {
  border: 1px solid !important;
}
</style>
